import React from 'react';
import BlockImage from './BlockImage';
import { ArticleTextStandardImage } from '../../../../ArticleImage/ArticleTextStandardImage';
import { CloudinaryImageType } from '../../../../../../../types/CloudinaryImageType';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ImageSerializerProps {
  value: { image: CloudinaryImageType; captionMode?: 'text-right' | 'text-left' };
}

const Image = ({ value: { image } }: ImageSerializerProps) => <BlockImage image={image} />;

export const ImageSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value: { image, captionMode } }: ImageSerializerProps) => (
      <ArticleTextStandardImage image={image} captionMode={captionMode} />
    );
  }
  return ({ value }: ImageSerializerProps) => <Image value={value} />;
};
